"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const rfid_tag_hauler_types_1 = require("./rfid-tag-hauler.types");
const app_types_1 = require("../../../app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    dataItem: {
        id: '',
        contractor_id: '',
        contractor_name: '',
        hauler_no: '',
        hauler_spec: '',
        is_active: false,
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
        rfid_tag: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const rfidTagHaulerReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [rfid_tag_hauler_types_1.rfidTagHaulerTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [rfid_tag_hauler_types_1.rfidTagHaulerTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [rfid_tag_hauler_types_1.rfidTagHaulerTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isLoading: false, isSuccess: false, isLoadingSubmit: false });
    },
    [rfid_tag_hauler_types_1.rfidTagHaulerTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingSubmit, mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [rfid_tag_hauler_types_1.rfidTagHaulerTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [rfid_tag_hauler_types_1.rfidTagHaulerTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [rfid_tag_hauler_types_1.rfidTagHaulerTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, isLoading: true, mutationMode: false, isLoadingSubmit: isSuccess, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    }
});
exports.default = rfidTagHaulerReducer;
